import { useEffect, useState } from "react";
import Lenis from "lenis";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import WatchClips from "@/components/landing/WatchClips";
import WhoWeHelp from "@/components/landing/WhoWeHelp";
import WhatWeDo from "@/components/landing/WhatWeDo";
import Founder from "@/components/landing/Founder";
import HowItWorks from "@/components/landing/HowItWorks";
import Faq from "@/components/landing/Faq";
import FinalCta from "@/components/landing/FinalCta";
import Footer from "@/components/landing/Footer";
import BookingModal from "@/components/landing/BookingModal";

export default function Landing() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const openBooking = () => setBookingOpen(true);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div data-testid="landing-page" className="bg-[#08080A] text-[#F9F8F6]">
      <Nav onBook={openBooking} />
      <main>
        <Hero onBook={openBooking} />
        <Marquee />
        <WatchClips />
        <WhoWeHelp />
        <WhatWeDo />
        <Founder onBook={openBooking} />
        <HowItWorks onBook={openBooking} />
        <Faq />
        <FinalCta onBook={openBooking} />
      </main>
      <Footer />
      <BookingModal open={bookingOpen} onClose={() => setBookingOpen(false)} />
    </div>
  );
}
